export const blogArticles = [
  {
    slug: 'shcho-robyty-yakshcho-iphone-vpav-u-vodu',
    path: '/blog/shcho-robyty-yakshcho-iphone-vpav-u-vodu',
    title: 'Що робити, якщо iPhone впав у воду',
    metaTitle: 'Що робити, якщо iPhone впав у воду',
    metaDescription: 'Покроково пояснюємо, що робити, якщо iPhone впав у воду: чого не можна робити, коли нести в сервіс і як підвищити шанси на відновлення.',
    excerpt: 'Пояснюємо, чому не можна сушити iPhone феном, коли критично везти його в сервіс та як зберегти плату після контакту з водою.',
    h1: 'Що робити, якщо iPhone впав у воду',
    datePublished: '2026-03-31',
    keywords: ['що робити якщо iPhone впав у воду', 'ремонт iPhone після води Харків', 'iPhone після води що робити'],
    relatedServices: ['remont-iphone-pislia-vody', 'water-damage-repair'],
    faq: [
      { q: 'Чи можна заряджати iPhone після води?', a: 'Ні, зарядка може прискорити корозію та добити плату.' },
      { q: 'Чи допомагає рис після води?', a: 'Ні, рис не замінює професійне чищення та діагностику.' }
    ],
    sections: [
      {
        title: 'Перші хвилини після намокання',
        body: 'Вимкніть iPhone, не підключайте зарядку, зніміть чохол і не натискайте зайвий раз на кнопки. Чим менше струму та рухів усередині, тим більше шансів врятувати пристрій.'
      },
      {
        title: 'Чого робити не можна',
        body: 'Не сушіть смартфон феном, не кладіть на батарею, не розбирайте самостійно без досвіду і не перевіряйте постійно, чи він уже ожив. Це часто лише погіршує стан плати.'
      },
      {
        title: 'Коли їхати у сервіс',
        body: 'Найкраще привезти телефон у сервіс протягом перших годин. Для iPhone після залиття швидке чищення та діагностика критично впливають на шанс відновлення.'
      }
    ]
  },
  {
    slug: 'skilky-koshtuie-zamina-skla-iphone-14',
    path: '/blog/skilky-koshtuie-zamina-skla-iphone-14',
    title: 'Скільки коштує заміна скла iPhone 14',
    metaTitle: 'Скільки коштує заміна скла iPhone 14 у Харкові',
    metaDescription: 'Розбираємо, від чого залежить ціна заміни скла iPhone 14 у Харкові, коли можна міняти лише скло і коли потрібна заміна всього дисплея.',
    excerpt: 'Пояснюємо різницю між заміною скла та повною заміною дисплея iPhone 14 і від чого формується вартість ремонту.',
    h1: 'Скільки коштує заміна скла iPhone 14',
    datePublished: '2026-03-31',
    keywords: ['скільки коштує заміна скла iPhone 14', 'заміна скла iPhone 14 Харків', 'ціна екрана iPhone 14 Харків'],
    relatedServices: ['zamena-skla-iphone', 'screen-replacement'],
    faq: [
      { q: 'Коли можна міняти тільки скло iPhone 14?', a: 'Коли матриця ціла, є зображення і сенсор працює коректно.' },
      { q: 'Що дорожче: скло чи весь екран?', a: 'Повна заміна дисплея дорожча, але інколи це єдиний правильний варіант.' }
    ],
    sections: [
      {
        title: 'Від чого залежить ціна',
        body: 'Вартість залежить від фактичного стану матриці, сенсора, рамки та наявності додаткових пошкоджень після падіння. Без огляду легко недооцінити обсяг робіт.'
      },
      {
        title: 'Коли достатньо заміни скла',
        body: 'Якщо дисплей показує без плям, смуг і чорних зон, а сенсор працює по всій площі, шанси на заміну лише скла високі. Це дозволяє зменшити підсумкову вартість ремонту.'
      },
      {
        title: 'Чому важлива діагностика',
        body: 'Перед остаточним кошторисом потрібно перевірити корпус, рамку та Face ID. Для iPhone 14 це важливо, бо після удару пошкодження часто виходять за межі одного скла.'
      }
    ]
  },
  {
    slug: 'yak-vybraty-akumuliator-dlia-samsung',
    path: '/blog/yak-vybraty-akumuliator-dlia-samsung',
    title: 'Як вибрати акумулятор для Samsung',
    metaTitle: 'Як вибрати акумулятор для Samsung',
    metaDescription: 'Пояснюємо, як вибрати акумулятор для Samsung, на що дивитися при заміні та чому важливо ставити батарею під конкретну модель Galaxy.',
    excerpt: 'Розповідаємо, як підібрати акумулятор для Samsung без помилки та чому не варто ставити сумнівні батареї без перевірки.',
    h1: 'Як вибрати акумулятор для Samsung',
    datePublished: '2026-03-31',
    keywords: ['як вибрати акумулятор для Samsung', 'заміна батареї Samsung Харків', 'акумулятор Samsung Galaxy поради'],
    relatedServices: ['zamena-batarei-samsung', 'battery-replacement'],
    faq: [
      { q: 'Чи можна ставити універсальну батарею Samsung?', a: 'Ні, акумулятор потрібно підбирати під конкретну модель Galaxy.' },
      { q: 'Коли варто міняти батарею Samsung?', a: 'Коли телефон швидко сідає, гріється або вимикається без причини.' }
    ],
    sections: [
      {
        title: 'Підбір за моделлю',
        body: 'У Samsung десятки варіацій навіть у межах однієї серії, тому батарею потрібно підбирати точно за моделлю, а не на око. Це впливає на безпеку і стабільність зарядки.'
      },
      {
        title: 'Ознаки якісної батареї',
        body: 'Хороший акумулятор має стабільну ємність, не перегрівається та коректно працює з контролером живлення. Саме тому важливо ставити перевірені деталі.'
      },
      {
        title: 'Чому краще міняти у сервісі',
        body: 'У сервісі одразу перевіряють шлейфи, розʼєм, нагрів та поведінку телефону після встановлення. Це зменшує ризик повторного ремонту і прихованих проблем.'
      }
    ]
  },
  {
    slug: 'yak-zrozumity-shcho-batareia-telefonu-vzhe-znyshchena',
    path: '/blog/yak-zrozumity-shcho-batareia-telefonu-vzhe-znyshchena',
    title: 'Як зрозуміти, що батарея телефону вже зношена',
    metaTitle: 'Як зрозуміти, що батарея телефону вже зношена',
    metaDescription: 'Основні симптоми зношеної батареї телефону: швидкий розряд, нагрів, вимкнення на холоді та здуття акумулятора.',
    excerpt: 'Зібрали ключові ознаки, що пора міняти батарею телефону, і пояснили, коли вже не варто відкладати ремонт.',
    h1: 'Як зрозуміти, що батарея телефону вже зношена',
    datePublished: '2026-03-31',
    keywords: ['зношена батарея телефону ознаки', 'заміна батареї Харків', 'телефон швидко розряджається що робити'],
    relatedServices: ['battery-replacement', 'zamena-batarei-samsung'],
    faq: [
      { q: 'Чи небезпечна здута батарея?', a: 'Так, її потрібно міняти якнайшвидше і не продовжувати користування.' },
      { q: 'Чи допоможе калібрування?', a: 'Якщо батарея фізично зношена, калібрування проблему не вирішить.' }
    ],
    sections: [
      {
        title: 'Швидкий розряд і нагрів',
        body: 'Якщо телефон почав розряджатися вдвічі швидше, сильно гріється під час зарядки або звичайного користування, це перший сигнал про втрату ємності.'
      },
      {
        title: 'Стрибки відсотків та вимкнення',
        body: 'Ще одна типова ознака: смартфон показує 30%, а потім раптово вимикається або різко падає до 5%. Це часто трапляється зі старими батареями в холодну пору року.'
      },
      {
        title: 'Коли міняти негайно',
        body: 'Якщо корпус розпирає, екран трохи піднявся або акумулятор явно здувся, відкладати ремонт не можна. Це вже питання безпеки, а не лише комфорту.'
      }
    ]
  },
  {
    slug: 'chomu-telefon-ne-zariadzhaietsia-i-shcho-z-tym-robyty',
    path: '/blog/chomu-telefon-ne-zariadzhaietsia-i-shcho-z-tym-robyty',
    title: 'Чому телефон не заряджається і що з цим робити',
    metaTitle: 'Чому телефон не заряджається і що робити',
    metaDescription: 'Пояснюємо, як відрізнити проблему з кабелем від несправності розʼєму зарядки, батареї або контролера живлення.',
    excerpt: 'Пояснюємо, як зрозуміти, чи винен кабель, блок живлення, батарея або сам розʼєм зарядки телефону.',
    h1: 'Чому телефон не заряджається і що з цим робити',
    datePublished: '2026-03-31',
    keywords: ['телефон не заряджається що робити', 'ремонт розʼєму зарядки Харків', 'чому телефон не бере заряд'],
    relatedServices: ['charging-port-repair', 'battery-replacement'],
    faq: [
      { q: 'Чи може причина бути в батареї?', a: 'Так, не завжди винен саме розʼєм. Іноді проблема в акумуляторі або контролері живлення.' },
      { q: 'Чи можна самому чистити розʼєм?', a: 'Обережно так, але без металевих предметів і без натискання всередину порту.' }
    ],
    sections: [
      {
        title: 'Почніть із простого',
        body: 'Спершу перевірте інший кабель і блок живлення. У багатьох випадках проблема не в телефоні, а в аксесуарах, які втратили контакт або пошкодилися.'
      },
      {
        title: 'Коли винен розʼєм зарядки',
        body: 'Якщо кабель працює лише під певним кутом, штекер люфтить або зарядка зникає при легкому русі, високий шанс, що причина саме в порту.'
      },
      {
        title: 'Коли потрібна глибша діагностика',
        body: 'Якщо після заміни кабелю нічого не змінюється, потрібно перевірити батарею, плату та контролер живлення. Тут уже краще не експериментувати вдома.'
      }
    ]
  },
  {
    slug: 'chi-varto-miniaty-ekran-samsung-chy-kupuvaty-novyi-telefon',
    path: '/blog/chi-varto-miniaty-ekran-samsung-chy-kupuvaty-novyi-telefon',
    title: 'Чи варто міняти екран Samsung чи купувати новий телефон',
    metaTitle: 'Чи варто міняти екран Samsung чи купувати новий телефон',
    metaDescription: 'Пояснюємо, коли заміна екрана Samsung Galaxy вигідніша за покупку нового смартфона і на що звертати увагу перед ремонтом.',
    excerpt: 'Порівнюємо вартість заміни дисплея Samsung з купівлею нового телефону та підказуємо, коли ремонт справді вигідний.',
    h1: 'Чи варто міняти екран Samsung чи купувати новий телефон',
    datePublished: '2026-03-31',
    keywords: ['заміна екрана Samsung чи новий телефон', 'ремонт Samsung Харків', 'екран Samsung Galaxy ціна Харків'],
    relatedServices: ['zamena-ekrana-samsung', 'samsung-repair'],
    faq: [
      { q: 'Коли ремонт Samsung невигідний?', a: 'Коли окрім екрана пошкоджена плата, корпус або кілька вузлів, і сума ремонту стає занадто високою.' },
      { q: 'Чи збережуться дані після заміни екрана?', a: 'У більшості випадків так, адже заміна дисплея не зачіпає дані користувача.' }
    ],
    sections: [
      {
        title: 'Коли ремонт вигідний',
        body: 'Якщо смартфон відносно свіжий, добре працює та влаштовує вас за характеристиками, заміна екрана майже завжди вигідніша за купівлю нового пристрою.'
      },
      {
        title: 'Коли краще думати про новий телефон',
        body: 'Якщо окрім екрана є проблеми з батареєю, корпусом, камерою чи платою, варто попросити сервіс порахувати повний кошторис, а не лише дисплей.'
      },
      {
        title: 'Чому важливий огляд перед рішенням',
        body: 'На практиці рішення приймають після огляду. Часто запит на заміну екрана Samsung приховує ще кілька пошкоджених вузлів після удару.'
      }
    ]
  },
  {
    slug: 'remont-telefonu-pislia-vody-harantii-ta-ryzyky',
    path: '/blog/remont-telefonu-pislia-vody-harantii-ta-ryzyky',
    title: 'Ремонт телефону після води: гарантії та ризики',
    metaTitle: 'Ремонт телефону після води: гарантії та ризики',
    metaDescription: 'Розбираємо, які ризики є у телефона після води, від чого залежить успіх ремонту та яку гарантію реально можна дати після залиття.',
    excerpt: 'Чесно пояснюємо, чому ремонт після води складніший за інші види робіт і що впливає на гарантію після залиття.',
    h1: 'Ремонт телефону після води: гарантії та ризики',
    datePublished: '2026-03-31',
    keywords: ['ремонт телефону після води гарантія Харків', 'ремонт після залиття Харків', 'після води телефон гарантія'],
    relatedServices: ['water-damage-repair', 'remont-iphone-pislia-vody'],
    faq: [
      { q: 'Чому після води не завжди дають довгу гарантію?', a: 'Тому що наслідки корозії можуть проявлятися поступово і залежать від масштабу залиття.' },
      { q: 'Що підвищує шанс на успіх?', a: 'Швидке звернення, відсутність спроб заряджати телефон і професійне чищення у сервісі.' }
    ],
    sections: [
      {
        title: 'Чим залиття відрізняється від інших поломок',
        body: 'Після води проблема часто не обмежується одним модулем. Корозія може вражати кілька зон плати, шлейфи та розʼєми, тому ремонт складніший за звичайну заміну екрана.'
      },
      {
        title: 'Від чого залежить гарантія',
        body: 'Гарантія залежить від масштабу пошкодження, того, які вузли постраждали, і наскільки швидко клієнт звернувся до сервісу після намокання.'
      },
      {
        title: 'Як знизити ризики',
        body: 'Головне не запускати корозію. Якщо телефон намок, не відкладайте візит у сервіс, навіть якщо пристрій ще подає ознаки життя.'
      }
    ]
  },
  {
    slug: 'shvydkyi-remont-smartfoniv-na-prospekti-yuvileinyi',
    path: '/blog/shvydkyi-remont-smartfoniv-na-prospekti-yuvileinyi',
    title: 'Швидкий ремонт смартфонів на проспекті Ювілейний',
    metaTitle: 'Швидкий ремонт смартфонів на проспекті Ювілейний',
    metaDescription: 'Чому клієнти шукають швидкий ремонт смартфонів на проспекті Ювілейний у Харкові та які роботи реально виконати в день звернення.',
    excerpt: 'Пояснюємо, які ремонти реально зробити швидко на Ювілейному і чому локальна сторінка добре працює для гарячих запитів.',
    h1: 'Швидкий ремонт смартфонів на проспекті Ювілейний',
    datePublished: '2026-03-31',
    keywords: ['швидкий ремонт смартфонів проспект Ювілейний', 'терміновий ремонт iPhone на Ювілейному Харків', 'ремонт телефонів Ювілейний Харків'],
    relatedServices: ['terminovyi-remont-telefoniv-kharkiv', 'iphone-repair'],
    faq: [
      { q: 'Які ремонти реально зробити швидко?', a: 'Часто це батарея, екран, розʼєм зарядки, динамік або мікрофон.' },
      { q: 'Чому важлива локальна сторінка під район?', a: 'Тому що люди шукають сервіс поруч із собою, а локальні запити мають вищу конверсію.' }
    ],
    sections: [
      {
        title: 'Локальний пошук дає гарячий трафік',
        body: 'Коли людина шукає швидкий ремонт смартфонів на проспекті Ювілейний, вона вже близька до звернення. Такі запити часто конвертуються краще за загальні сторінки.'
      },
      {
        title: 'Що реально полагодити в день звернення',
        body: 'У день звернення часто закриваються питання з екраном, батареєю, зарядкою, динаміком або мікрофоном. Саме ці послуги мають вести на форму заявки.'
      },
      {
        title: 'Як сторінка допомагає SEO',
        body: 'Сторінка під район і вулицю допомагає закривати локальні запити, посилює релевантність сайту для Google і створює додаткові точки входу з довгого хвоста.'
      }
    ]
  }
];

export const blogArticleMap = Object.fromEntries(blogArticles.map((article) => [article.slug, article]));
